import { lasErrorCodeMap } from '../las/utils/scLoanError';
import { store } from '../utils/userStore';

export const defaultUnityHeaders = {
  'Content-Type': 'application/json',
  'x-gateway-sdk-version': `v${VERSION}`,
  'x-gateway-sdk-type': 'web',
};

type HttpMethod = 'GET' | 'POST';
let unityBaseUrl = '';
function getUnityApiUrl(loanEnv: string = 'primary'): string {
  if (!unityBaseUrl) {
    // if loanEnv is other than primary, and preview env url template is available, return corresponding unity api url
    if (UNITY_API_PREVIEW_URL_TEMPLATE && loanEnv !== 'primary') {
      unityBaseUrl = UNITY_API_PREVIEW_URL_TEMPLATE.replace(
        'ENV_NAME',
        loanEnv,
      );
    }
  }
  // otherwise, return default unity api url
  return unityBaseUrl || UNITY_API_URL;
}

const unityApiHandler = async <T>(
  method: HttpMethod,
  endpoint: string,
  data?: any,
  customHeaders?: Record<string, string>,
): Promise<T> => {
  let url = `${getUnityApiUrl(store.loanEnv)}/client/${
    store.loanGateway
  }${endpoint}`;
  const headers = {
    ...defaultUnityHeaders,
    ...customHeaders,
  };

  const options: RequestInit = {
    method,
    headers,
    credentials: 'include',
  };

  if (method !== 'GET' && data) {
    options.body = JSON.stringify(data);
  } else if (method === 'GET' && data) {
    const params = new URLSearchParams(data);
    url += `?${params.toString()}`;
  }

  const response = await fetch(url, options);
  if (response.ok) {
    return response.json();
  }
  const errorMessage = await response
    .json()
    .catch(() => lasErrorCodeMap.INTERNAL_ERROR);
  throw new Error(errorMessage);
};

export const craftInteractionHeader = (interactionToken: string) => ({
  'x-gateway-interaction': interactionToken,
});

export default unityApiHandler;
